import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isMetaBlockedRoute } from '@/lib/fbPixel';

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
  }
}

/** Query parameters that may carry personal data — removed before any PageView. */
const PII_PARAMS = ['email', 'phone', 'name', 'first_name', 'last_name', 'token', 'code'];

/**
 * Facebook Pixel SPA Tracking Component (Pixel 994550223073937, initialised in index.html).
 * Tracks PageView on route changes, skipping /login, /dashboard and /admin, and strips
 * personal-data query parameters from the address first so the pixel never sees them.
 */
const FacebookPixel = () => {
  const location = useLocation();

  useEffect(() => {
    if (isMetaBlockedRoute(location.pathname)) return;
    try {
      const url = new URL(window.location.href);
      let changed = false;
      PII_PARAMS.forEach((k) => {
        if (url.searchParams.has(k)) {
          url.searchParams.delete(k);
          changed = true;
        }
      });
      if (changed) window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
    } catch {
      /* ignore */
    }
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'PageView');
    }
  }, [location.pathname, location.search]);

  return null;
};

export default FacebookPixel;
